import { useNow } from './use-now';

export function useTagReplace(text: string) {
  const now = useNow({
    disabled: text.indexOf('{{datetime.today}}') === -1,
    formatter: (date: Date) => {
      const formattedDatetimeString = date.toLocaleString('sv-SE', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
        weekday: 'short',
        month: 'short',
        day: '2-digit',
      });

      const [weekday, day, month, time] = formattedDatetimeString.split(' ');

      const formattedMonth = month.replace('0', '');
      const formattedWeekday = weekday.charAt(0).toUpperCase() + weekday.slice(1);

      return `${formattedWeekday} ${day}  ${formattedMonth}  / ${time}`;
    },
  });

  if (text.includes('{{datetime.today}}')) {
    return text.replace(/\{\{datetime\.today\}\}/g, now);
  }

  return text;
}
